import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

import {
  IonApp,
  IonContent,
  IonIcon,
  IonImg,
  IonItem,
  IonLabel,
  IonList,
  IonListHeader,
  IonMenu,
  IonMenuToggle,
  IonRouterOutlet,
  IonSplitPane,
} from "@ionic/vue";
import { computed, ComputedRef, ref, watch } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";

import { Menu, MenuItem, User } from "./types";
import {
  executeAdditionalControl,
  getCurrentElement,
  getDefautlLink,
  getIcon,
} from "./utils";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const getMenu = () => {
  const complete_menu: MenuItem[] = [];

  for (const item_title of order.value) {
    complete_menu.push(menu.items[item_title]);
  }

  return complete_menu;
};
const selectTitle = (index: number) => {
  store.state.menu.index = index;
  sessionStorage.setItem("selected_item", order.value[index]);
};
const changeTitle = () => {
  const items_titles = Object.keys(menu.items);
  const selected_item = sessionStorage.getItem("selected_item");

  let urls: string[] | undefined;
  let tmp_index = -1;
  let count = 0;

  if (
    $route.name !== undefined &&
    user.value != undefined &&
    $route.name != "auth" &&
    $route.name != "logout"
  ) {
    if (
      selected_item != null &&
      (tmp_index = menu.items[selected_item].url_names[
        user.value.type
      ].findIndex((a) => a == ($route.name as string))) != -1
    ) {
      tmp_index = order.value.findIndex((a) => a == selected_item);
    } else {
      while (tmp_index == -1 && count < items_titles.length) {
        urls = menu.items[items_titles[count]].url_names[user.value.type];
        if (urls != undefined) {
          tmp_index = urls.findIndex((a) => a == $route.name);
        }
        count++;
      }
      if (tmp_index != -1) {
        tmp_index = order.value.findIndex((a) => a == items_titles[count - 1]);
      }
    }
    menu.index =
      tmp_index != -1
        ? tmp_index
        : order.value.findIndex(
            (a) => a == menu.default_item[(user.value as User).type]
          );
    sessionStorage.setItem("selected_item", order.value[tmp_index]);
    trigger.value++;
  }
};

const store = useStore();
const $route = useRoute();
const menu: Menu = store.state.menu;

const image = computed(() => require("./assets/Logo_LIVO_Path.png"));
const trigger = ref(0);
const user: ComputedRef<User | undefined> = computed(
  () => store.state.user ?? User.getLoggedUser()
);
const order = computed(() =>
  user.value != undefined
    ? menu.order[user.value.type].filter((a) =>
        user.value != undefined
          ? executeAdditionalControl(user.value, menu.items[a]) != false
          : false
      )
    : []
); // getMenuOrder function. Not used the proper function to avoid the loss of reactivity

changeTitle();
watch($route, changeTitle);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_unref(IonApp), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonSplitPane), { "content-id": "main-content" }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonMenu), {
            "content-id": "main-content",
            type: "overlay"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonContent), null, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonList), { id: "menu-list" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonListHeader), { class: "ion-padding-bottom" }, {
                        default: _withCtx(() => [
                          (_unref(user) != undefined)
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 0,
                                to: { name: _unref(getDefautlLink)(_unref(user).type).name }
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(IonImg), {
                                    src: _unref(image),
                                    alt: "LIVO Campus Logo",
                                    style: {"height":"90px"}
                                  }, null, 8, ["src"])
                                ]),
                                _: 1
                              }, 8, ["to"]))
                            : (_openBlock(), _createBlock(_unref(IonImg), {
                                key: 1,
                                src: _unref(image),
                                alt: "LIVO Campus Logo",
                                style: {"height":"90px"}
                              }, null, 8, ["src"]))
                        ]),
                        _: 1
                      }),
                      (_openBlock(), _createBlock(_unref(IonMenuToggle), {
                        "auto-hide": false,
                        key: trigger.value
                      }, {
                        default: _withCtx(() => [
                          (_unref(user) != undefined)
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(getMenu(), (p, i) => {
                                return (_openBlock(), _createBlock(_unref(IonItem), {
                                  key: i,
                                  onClick: ($event: any) => (selectTitle(i)),
                                  "router-direction": "root",
                                  "router-link": { name: p.url_names[_unref(user).type][0] },
                                  lines: "none",
                                  detail: false,
                                  class: _normalizeClass(["hydrated", { selected: _unref(menu).index === i }])
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(IonIcon), {
                                      "aria-hidden": "true",
                                      class: "ion-padding-end",
                                      ios: _unref(getIcon)(p.icon_ref).ios,
                                      md: _unref(getIcon)(p.icon_ref).md
                                    }, null, 8, ["ios", "md"]),
                                    _createVNode(_unref(IonLabel), { "text-wrap": "" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(getCurrentElement)(_unref(order)[i])), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick", "router-link", "class"]))
                              }), 128))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(IonRouterOutlet), { id: "main-content" })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})